import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { SidebarComponent } from './sidebar/sidebar.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { Router, RouterOutlet, RouterLink, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonService } from '../service/common.service';
import { ApiService } from '../service/api.service';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    RouterLink,
    CommonModule,
    MatSidenavModule,
    MatListModule,
    SidebarComponent,
    HeaderComponent,
    FooterComponent,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export class LayoutComponent {
  isSidenavOpen = false;
  userData: any;
  city: any = '';
  isRouteLoading = false;

  toggleSidenav() {
    this.isSidenavOpen = !this.isSidenavOpen;
  }

  constructor(private common: CommonService, private router: Router,
    private api: ApiService,
  ) {
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
      const u: any = localStorage.getItem('userData');
      this.userData = u ? JSON.parse(u) : null;
    }
    this.city = this.common.getLocation()?.city || '';
    this.getCategoryData();

    // Track route loading state to show skeleton and ensure page scrolls to top on navigation
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.isRouteLoading = true;
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.isRouteLoading = false;
        if (event instanceof NavigationEnd) {
          this.scrollToTop();
        }
      }
    });
  }

  scrollToTop(): void {
    if (typeof window === 'undefined') return;

    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    if (document.documentElement) document.documentElement.scrollTop = 0;
    if (document.body) document.body.scrollTop = 0;

    const sidenav = document.querySelector('mat-sidenav-content, .mat-sidenav-content');
    if (sidenav) sidenav.scrollTop = 0;
    const main = document.getElementById('main-content');
    if (main) main.scrollTop = 0;

    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      if (document.documentElement) document.documentElement.scrollTop = 0;
      if (document.body) document.body.scrollTop = 0;
      if (sidenav) sidenav.scrollTop = 0;
      if (main) main.scrollTop = 0;
    });

    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      if (document.documentElement) document.documentElement.scrollTop = 0;
      if (document.body) document.body.scrollTop = 0;
      if (sidenav) sidenav.scrollTop = 0;
    }, 50);
  }

  gotoUrls(ele: string) {
    this.router.navigateByUrl(ele);
  }

  allCategoryData: any = [];
  getCategoryData() {
    const body = {
      segmentType: 'CATEGORY',
    };
    this.api.commonPost('fetch/segment', body).subscribe(
      (res: any) => {
        if (res.status && res.statusCode == 200) {
          res.response.forEach((ele: any) => {
            if (ele.url && !ele.url.startsWith('http')) {
              ele.url = this.api.imageUrl + ele.url;
            }
          });
          this.allCategoryData = res.response;
        } else {
          this.allCategoryData = [];
        }
      },
      (error) => {
        this.allCategoryData = [];
      }
    );
  }

  gotoLinksCategory(data: any) {
    if (data.name == 'B2B') {
      this.router.navigate(['/b2b']);
    } else if (data.name == 'Construction') {
      this.router.navigate(['/construction']);
    } else if (data.name == 'Interior') {
      this.router.navigate(['/interior']);
    } else if (data.name == 'Cars') {
      if (typeof window !== 'undefined') window.open('https://btechcars.com/', '_blank');
    } else if (data.name == 'Apparel & Garments') {
      this.router.navigate(['/apparel-garments']);
    } else if (data.name == 'Medicine') {
      if (typeof window !== 'undefined') window.open('https://www.bpharmastore.com/', '_blank');
    } else if (data.name == 'Real State') {
      if (typeof window !== 'undefined') window.open('https://property.btechmart.in/', '_blank');
    }
  }

  getCategoryUrl(data: any): string {
    if (!data?.name) return '/';
    const name = data.name.trim();
    if (name === 'B2B') return '/b2b';
    if (name === 'Construction') return '/construction';
    if (name === 'Interior') return '/interior';
    if (name === 'Cars') return 'https://btechcars.com/';
    if (name === 'Apparel & Garments') return '/apparel-garments';
    if (name === 'Medicine') return 'https://www.bpharmastore.com/';
    if (name === 'Real State' || name === 'Real Estate') return 'https://property.btechmart.in/';
    return '/';
  }

  isExternalUrl(url: string): boolean {
    return url ? url.startsWith('http') : false;
  }
}
